module.exports = __webpack_public_path__ + "img/cultural_grid.7c11aeb5.svg";